import { Component, ReactNode } from "react";
export default class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (
      <div role="alert" className="p-6">
        <h1 className="text-xl font-semibold">This page could not open</h1>
        <button
          className="mt-4 rounded-lg bg-purple-600 px-4 py-2 text-white"
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
        <a className="ml-4 text-purple-600" href="/dashboard">
          Dashboard
        </a>
      </div>
    ) : (
      this.props.children
    );
  }
}
